import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { get } from 'lodash';
import { useIntl } from 'react-intl';

import { votePost } from '../Services/Api';
import queriesConfig from '../Services/queriesConfig';
import VotesTypes from '../Utils/Types/VoteTypes';
import Analytics from '../Services/AnalyticsService';
import { canOnlyUpvote, getReactionVotes, voteTypeValue } from '../Utils/Post/votes';
import { validateCanVote } from '../Utils/Post/securedStrategies';
import { useNotifications } from '@toolpad/core/useNotifications';
import { notify } from '../Utils/NotificationUtils';

const getVoteType = (vote: any) => {
  if (vote === 1) {
    return VotesTypes.SUPPORT;
  }
  if (vote === -1) {
    return VotesTypes.NOT_SUPPORT;
  }
  return null;
};

export default (post: any, trackingProps: any) => {
  const intl = useIntl();
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const notifications = useNotifications();
  const queryClient = useQueryClient();
  const parentPost = post.included.source;
  const reactionVotes = getReactionVotes(parentPost);
  const selectedVote = getVoteType(post?.meta?.user_vote_value);
  const vote = async (voteType: any) => {
    const isCancelingVote = selectedVote && selectedVote === voteType;

    await validateCanVote(post?.included?.source, async () => {
      try {
        setLoading(true);

        const response = await votePost(post.id, voteTypeValue(voteType), isCancelingVote);

        const updatedParentPost = (get(response, 'data.data.included.source') || {}) as any;

        // In case voting directly on a post liste, we need to refresh the whole list
        // to get the new can_create_vote which is depending on budgets, numbers of votes, …
        queryClient.invalidateQueries(['post-children']);

        queryClient.setQueryData(
          queriesConfig.getPost(updatedParentPost?.id).queryKey,
          (oldData: any) => {
            return oldData
              ? {
                  ...oldData,
                  data: {
                    ...oldData?.data,
                    data: {
                      ...oldData?.data?.data,
                      ...updatedParentPost,
                    },
                  },
                }
              : oldData;
          },
        );

        queryClient.setQueryData(queriesConfig.getPost(post.id).queryKey, response);

        setLoading(false);

        if (!isCancelingVote) {
          Analytics.track('Post', 'Vote Post', `Vote ${voteType}`, {
            'Post ID': post.id,
            ...trackingProps,
          });
          notify(notifications, intl.formatMessage({ id: 'BUTTONS.VOTE.TOAST.SUCCESS' }));
        } else {
          notify(notifications, intl.formatMessage({ id: 'BUTTONS.VOTE.TOAST.CANCEL' }));
        }
      } catch (postError) {
        setError(postError);
        setLoading(false);
      }
    });
  };

  return {
    vote,
    selectedVote,
    reactionVotes,
    canOnlyUpvote,
    loading,
    error,
  };
};
